import { GetProductDetail } from "../../services/modules/product";
import { useFetch } from "./config";
import { isReactSnap } from "../../utils/react-snap";

export function useFetchProductDetail(productId) {
  return useFetch({
    queryKeys: ["product-detail", productId],
    queryFn: async () => {
      const { resultData } = await GetProductDetail({
        product_id: parseInt(productId),
      });
      // resultData is an array, return first item
      return Array.isArray(resultData) ? resultData[0] : resultData;
    },
    enabled: !isReactSnap() && !!productId,
  });
}
